export const lotsizes = [
  1, 2, 5, 10, 50, 50, 70, 100, 100, 100, 120, 150, 150, 200, 500, 700, 1000,
  2000, 2500, 5000, 10000,
];
